import React, { useState } from "react";

import { addDoc, collection } from "firebase/firestore";

import { toast } from "react-toastify";

import { handleImageChange, handleImageSubmit } from "../../Utility/utils";

import { db } from "../../Config/Firebase/config";

import "./carousel.css";

const CarouselAdmin = () => {
  const [title, setTitle] = useState("");

  const [file, setFile] = useState(null);

  const [imageDownloadURL, setImageDownloadURL] = useState("");

  const [uploading, setUploading] = useState(false);

  // ============================================================
  // HANDLE FORM SUBMIT
  // ============================================================

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (title.trim() === "") {
      toast.warning("Please Enter Carousel Title");
      return;
    }

    if (file === null) {
      toast.warning("Please Select an Image");
      return;
    }

    try {
      setUploading(true);

      // --------------------------------------------------------
      // Upload image to Cloudinary
      // Folder: Home/lts
      // --------------------------------------------------------

      await handleImageSubmit(file, setFile, setImageDownloadURL, "lts/carousel");
    } catch (error) {
      console.error("Image Upload Error:", error);

      toast.error("Something went wrong while uploading image");

      setUploading(false);

      return;
    }
  };

  // ============================================================
  // SAVE DATA TO FIRESTORE AFTER IMAGE UPLOAD
  // ============================================================

  const saveCarouselData = async (downloadURL) => {
    try {
      await addDoc(collection(db, "carousel"), {
        title: title.trim(),
        image: downloadURL,
      });

      toast.success("Data uploaded successfully!");

      // Reset form
      setTitle("");
      setFile(null);
      setImageDownloadURL("");
      setUploading(false);
    } catch (error) {
      console.error("Firestore Error:", error);

      toast.error("Could not save carousel data");

      setUploading(false);
    }
  };

  // ============================================================
  // WATCH FOR CLOUDINARY URL
  // ============================================================

  React.useEffect(() => {
    if (imageDownloadURL !== "") {
      saveCarouselData(imageDownloadURL);
    }
  }, [imageDownloadURL]);

  // ============================================================
  // HANDLE IMAGE SELECTION
  // ============================================================

  const onImageChange = (event) => {
    handleImageChange(event, setFile);
  };

  // ============================================================
  // UI
  // ============================================================

  return (
    <div className="carousel-admin-container">
      <div className="carousel-admin-heading">
        <h3>Carousel</h3>
      </div>

      <div className="carousel-admin-form">
        <form onSubmit={handleSubmit}>
          {/* TITLE */}

          <div className="form-group">
            <label htmlFor="title">Title:</label>

            <input
              type="text"
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
              disabled={uploading}
            />
          </div>

          {/* IMAGE */}

          <div className="form-group">
            <label htmlFor="file">Choose Image:</label>

            <input
              type="file"
              id="file"
              accept="image/*"
              onChange={onImageChange}
              required
              disabled={uploading}
            />
          </div>

          {/* SUBMIT */}

          <button className="btn" type="submit" disabled={uploading}>
            {uploading ? "Uploading..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CarouselAdmin;
